export const POST = async (url: string, body: any) => {
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
        credentials: "include" // Ensure cookies are included in the request
    });

    if (!response.ok) {
        throw new Error(response.statusText || `Failed to POST to ${url}`);
    }

    return response.json();
};

export const POSTForm = async (url: string, data: Record<string, any>) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value as string | Blob);
    });

    const response = await fetch(url, {
        method: "POST",
        body: formData,
        credentials: "include" // Ensure cookies are included in the request
    });

    if (!response.ok) {
        throw new Error(response.statusText || `Failed to POST to ${url}`);
    }

    return response.json();
};

export const GET = async (url: string) => {
    const response = await fetch(url, {
        credentials: "include" // Ensure cookies are included in the request
    });

    if (!response.ok) {
        throw new Error(response.statusText || `Failed to GET from ${url}`);
    }

    return response.json();
};

export const GETBlob = async (url: string): Promise<Blob> => {
    const response = await fetch(url, {
        credentials: "include" // Ensure cookies are included in the request
    });

    if (!response.ok) {
        throw new Error(response.statusText || `Failed to GET Blob from ${url}`);
    }

    return response.blob();
};

export const POSTBlob = async (url: string, body: any): Promise<Blob> => {
    const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        credentials: "include" // Ensure cookies are included in the request
    });

    if (!response.ok) {
        throw new Error(response.statusText || `Failed to POST Blob to ${url}`);
    }

    return response.blob();
};

export const DELETE = async (url: string, body: any) => {
    const response = await fetch(url, {
        method: "DELETE",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
        credentials: "include" // Ensure cookies are included in the request
    });

    if (!response.ok) {
        throw new Error(response.statusText || `Failed to DELETE from ${url}`);
    }

    return response.json();
};
